import React from 'react';
import { NavLink } from 'react-router-dom';
import { apiGet, apiPost, apiPut } from '../../../services/apiClient';
import { getCurrentUserCompanyId, getCurrentUserSubCompanyId, getRoles, getCurrentUserLogin } from '../../../services/userRights';
import CheckBoxInput from '../../../controls/checkBoxInput.jsx';
import SelectInput from '../../../controls/selectInput.jsx';
import TextInput from '../../../controls/textInput.jsx';
import CountryPhoneInput from '../../../controls/countryPhoneInput.jsx';
import Forbidden from '../../forbidden/forbidden.jsx';
import NotFound from '../../notFound/notFound.jsx';
import Grid from '../../../grid/grid.jsx';
import TripleStateCheckbox from '../../../controls/tripleStateCheckbox.jsx';
import InformationModal from '../../../modals/infoModal';

export default class AdminUserForm extends React.Component {
    constructor(args) {
        super(args);

        let userId = this.props.match.params.id;
        this.state = {
            id: userId ? userId : 0,
            busyCount: 0,
            lastResponseError: null,
            adminCompanyId: getCurrentUserCompanyId(),
            adminSubCompanyId: getCurrentUserSubCompanyId(),
            companies: [],
            subCompanies: [],
            costCenters: [],
            carriers: [],
            roles: [],
            users: [],
            errors: {},
            accessToken: null,
            user: {},
            columns: [
                {
                    renderTitle: () => this.renderSelectionTitle(),
                    fieldName: 'selection',
                    disableSort: true,
                    minWidth: 80,
                    expandPortion: 0,
                    isFixed: true,
                    cellClass: "text-center"
                },
                {
                    title: 'Юр. лицо',
                    fieldName: 'companyName',
                    filterType: 'string',
                    minWidth: 640
                }
            ],
            userCompanies: [],
            isUserCompaniesSelectedAll: false,
            selectedUserCompanyIds: []
        };

        this.infoModal = null;

        this.initUserData();
    }

    initUserData() {
        this.state.user = {
            login: "",
            password: "",
            email: "",
            name: "",
            surname: "",
            patronymic: "",
            isCrossSector: false,
            contactInfo: "",
            companyName: "",
            companyInn: "",
            companyId: null,
            subCompanyId: null,
            costCenterId: null,
            carrierId: null,
            roles: [],
            accessToken: null
        };
    }

    componentDidMount() {
        this.reload();
    }

    componentWillReceiveProps(newProps) {
        let userId = newProps.match.params.id;
        this.state.id = userId ? userId : 0;
        this.setState(this.state, () => {
            if (this.state.id > 0) {
                this.reloadUserData();
            } else {
                this.initUserData();
                this.setState(this.state);
            }
        });
    }

    updateBusyCount(inc) {
        this.setState((prevState, props) => {
            prevState.busyCount = prevState.busyCount + inc;
            return prevState;
        });
    }

    reload() {
        this.updateBusyCount(1);
        apiGet('ref/roles/list')
            .then(data => {
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    let currentRoles = getRoles();
                    let availableRoles = data.entries;
                    
                    // Если текущий пользователь - Клиентский менеджер (Coordinator), 
                    // то он может назначать только роли "Клиент" и "Администратор клиента"
                    if (currentRoles && currentRoles.includes('ClientAdmin') && !currentRoles.includes('Admin') && !currentRoles.includes('GlobalAdmin') && !currentRoles.includes('Coordinator')) {
                        availableRoles = data.entries.filter(role => 
                            role.name === 'Author' || role.name === 'Demo' || role.name === 'ClientAdmin'
                        );
                    }
                    
                    prevState.roles = availableRoles.map((entry, ind, array) => { 
                        return { value: entry.name, label: entry.displayName }; 
                    });
                    return prevState;
                });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });

        this.updateBusyCount(1);
        apiGet('ref/companies/list')
            .then(data => {
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    prevState.companies = data.entries.map((entry, ind, array) => { return { value: entry.id, label: `${entry.name} / ИНН ${entry.inn}`, inn: entry.inn }; });
                    return prevState;
                });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });

        this.updateBusyCount(1);
        apiGet('ref/users/list/' + (this.state.user.companyId ? '' + this.state.user.companyId : ''))
            .then(data => {
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    prevState.users = data.entries.map((entry, ind, array) => {
                        return {
                            value: entry.id,
                            label: entry.fullName,
                            isCrossSector: entry.isCrossSector,
                            subCompanyId: entry.subCompanyId,
                            costCenterId: entry.costCenterId
                        };
                    });
                    return prevState;
                });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });

        this.reloadUserData();
    }

    reloadUserData() {
        if (this.state.id > 0) {
            this.updateBusyCount(1);
            apiGet('admin/users/' + this.state.id)
                .then(data => {
                    this.updateBusyCount(-1);
                    data.password = "";
                    data.login = data.login ? data.login : "";
                    data.email = data.email ? data.email : "";
                    data.name = data.name ? data.name : "";
                    data.surname = data.surname ? data.surname : "";
                    data.patronymic = data.patronymic ? data.patronymic : "";
                    data.contactInfo = data.contactInfo ? data.contactInfo : "";
                    data.companyName = data.companyName ? data.companyName : "";
                    data.companyInn = data.companyInn ? data.companyInn : "";
                    data.accessToken = data.accessToken ? data.accessToken : "";
                    this.setState((prevState, props) => {
                        prevState.user = data;
                        prevState.selectedUserCompanyIds = data.selectedUserCompanies;
                        return prevState;
                    });
                    this.reloadCompanyRefs(data.companyId);
                    this.reloadSectorsRefs(data.companyId, data.subCompanyId);
                })
                .catch(err => {
                    this.updateBusyCount(-1);
                    if (err.status > 401) {
                        this.setState({ lastResponseError: err.status });
                    }
                });
        } else {
            apiGet('auth/users/check');

            let companyId = getCurrentUserCompanyId();
            this.updateBusyCount(1);
            apiGet('ref/companies/' + companyId)
                .then(data => {
                    this.updateBusyCount(-1);
                    this.setState((prevState, props) => {
                        prevState.user.companyName = data.name;
                        prevState.user.companyInn = data.inn;
                        return prevState;
                    });
                })
                .catch(err => {
                    this.updateBusyCount(-1);
                });

            this.setState((prevState, props) => {
                prevState.user.companyId = companyId;
                prevState.user.subCompanyId = prevState.adminSubCompanyId;
                return prevState;
            });

            this.reloadCompanyRefs(companyId);
            this.reloadSectorsRefs(companyId, this.state.adminSubCompanyId);
        }
    }

    reloadCompanyRefs(companyId) {
        let queryArgs = companyId ? '' + companyId : '';

        this.updateBusyCount(1);
        apiGet('ref/subcompanies/list/' + queryArgs)
            .then(data => {
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    prevState.subCompanies = data.entries.map((entry, ind, array) => { return { value: entry.id, label: entry.name }; });
                    return prevState;
                });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });
    }

    reloadSectorsRefs(companyId, subCompanyId) {
        let queryArgs = '';
        if (companyId) {
            queryArgs = ('' + companyId + '/') + (subCompanyId ? '' + subCompanyId : '');
        }

        this.updateBusyCount(1);
        apiGet('ref/costcenters/list/' + queryArgs)
            .then(data => {
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    let needClear = true;
                    prevState.costCenters = data.entries.map((entry, ind, array) => {
                        if (entry.id === prevState.user.costCenterId) {
                            needClear = false;
                        }
                        return { value: entry.id, label: entry.name };
                    });
                    if (needClear) {
                        prevState.user.costCenterId = null;
                    }
                    return prevState;
                });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });

        this.updateBusyCount(1);
        apiGet('ref/carriers/list/' + queryArgs)
            .then(data => {
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    let needClear = true;
                    prevState.carriers = data.entries.map((entry, ind, array) => {
                        if (entry.id === prevState.user.carrierId) {
                            needClear = false;
                        }
                        return { value: entry.id, label: entry.name };
                    });
                    if (needClear) {
                        prevState.user.carrierId = null;
                    }
                    return prevState;
                });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });
    }

    loadUserCompanies(settings, takeCount, skipCount, needOverlay) {
        return apiPost('admin/users/usercompanieslist', { settings: settings, takeCount, skipCount })
            .then(data => {
                this.updateBusyCount(needOverlay ? -1 : 0);
                let result = data.entries.map((entry, ind, array) => { return { id: entry.id, companyName: entry.name }; });
                this.setState({
                    userCompanies: result
                });
                return data.entries;
            })
            .catch(err => {
                this.updateBusyCount(needOverlay ? -1 : 0);
                if (err.status > 401) {
                    this.setState({ lastResponseError: err.status });
                }
            });
    }

    save() {
        let errors = this.validateForm();
        if (errors) {
            this.setErrors(errors);
        } else {
            var userData = {
                id: this.state.id,
                login: this.replaceEmptyString(this.state.user.email),
                password: this.replaceEmptyString(this.state.user.password),
                email: this.replaceEmptyString(this.state.user.email),
                name: this.state.user.name,
                surname: this.state.user.surname,
                patronymic: this.replaceEmptyString(this.state.user.patronymic),
                isCrossSector: this.state.user.isCrossSector,
                contactInfo: this.replaceEmptyString(this.state.user.contactInfo),
                companyId: this.state.user.companyId,
                subCompanyId: this.state.user.subCompanyId,
                costCenterId: this.state.user.costCenterId,
                carrierId: this.state.user.carrierId,
                comment: this.state.user.comment,
                roles: this.state.user.roles,
                accessToken: this.state.user.accessToken,
                selectedUserCompanies: this.state.selectedUserCompanyIds
            };

            if (this.state.id > 0) {
                apiPost('admin/users/' + this.state.id, userData)
                    .then(() => {
                        this.backToList();
                    })
                    .catch(errors => {
                        this.setErrors(errors.messages);
                    });
            } else {
                let authUserData = {
                    userName: `${userData.surname} ${userData.name} ${userData.patronymic}`,
                    email: userData.email,
                    password: userData.password,
                    phoneNumber: userData.contactInfo,
                    companyInn: this.state.user.companyInn
                };
                apiPost('admin/users/validate', userData)
                    .then(() => {
                        apiPost('auth/users/register', authUserData)
                            .then(() => {
                                apiPut('admin/users/new', userData)
                                    .then(() => {
                                        this.backToList();
                                    })
                                    .catch(errors => {
                                        this.setErrors(errors.messages);
                                    });
                            })
                            .catch((data) => {
                                let message = data && data.Errors ? `: ${data.Errors}` : '';
                                this.infoModal.open('Создание пользователя', `Не удалось зарегистрировать нового пользователя в системе Pooling${message}. Обратитесь в службу поддержки.`);
                            });
                    })
                    .catch(errors => {
                        this.setErrors(errors.messages);
                    });
            }
        }
    }

    setErrors(errors) {
        this.setState({ errors: errors });
    }

    replaceEmptyString(str) {
        if (this.isEmptyString(str)) {
            return null;
        } else {
            return str;
        }
    }

    validateForm() {
        var result = null;

        if (this.isEmptyString(this.state.user.email)) {
            result = result ? result : {};
            result.email = "Логин является обязательным полем";
        }

        if (this.state.id < 1 && this.isEmptyString(this.state.user.password)) {
            result = result ? result : {};
            result.password = "Пароль является обязательным полем";
        }

        if (this.state.user.isCrossSector && this.state.user.subCompanyId) {
            result = result ? result : {};
            result.isCrossSector = "Кросс-функция не может быть выставлен при заполненном Секторе";
        }

        if (this.isEmptyString(this.state.user.name)) {
            result = result ? result : {};
            result.name = "Имя является обязательным полем";
        } else if (this.state.user.name.length > 200) {
            result = result ? result : {};
            result.name = "Длина поля Имя не должна превышать 200 символов";
        }

        if (this.isEmptyString(this.state.user.surname)) {
            result = result ? result : {};
            result.surname = "Фамилия является обязательным полем";
        } else if (this.state.user.surname.length > 200) {
            result = result ? result : {};
            result.surname = "Длина поля Фамилия не должна превышать 200 символов";
        }

        if (!this.isEmptyString(this.state.user.patronymic) && this.state.user.patronymic.length > 200) {
            result = result ? result : {};
            result.patronymic = "Длина поля Отчество не должна превышать 200 символов";
        }

        if (!this.isEmptyString(this.state.user.email) && this.state.user.email.length > 255) {
            result = result ? result : {};
            result.email = "Длина поля Email не должна превышать 255 символов";
        }

        if (!this.isEmptyString(this.state.user.contactInfo) && this.state.user.contactInfo.length > 500) {
            result = result ? result : {};
            result.contactInfo = "Длина поля Телефон не должна превышать 500 символов";
        }

        if (!this.isEmptyString(this.state.user.comment) && this.state.user.comment.length > 500) {
            result = result ? result : {};
            result.comment = "Длина поля Комментарий не должна превышать 500 символов";
        }

        if (!this.state.user.roles || this.state.user.roles.length < 1) {
            result = result ? result : {};
            result.roles = "Необходимо указать хотя бы одну роль";
        } else if (this.state.user.roles.length > 1 && this.state.user.roles.includes("Carrier")) {
            result = result ? result : {};
            result.roles = "Пользователь с ролью Транспортная компания не может иметь никаких других ролей";
        }

        if (!this.state.user.carrierId && this.state.user.roles.includes("Carrier")) {
            result = result ? result : {};
            result.carrierId = "Транспортная компания является обязательным полем для пользователей с соответствующей ролью";
        }

        return result;
    }

    isEmptyString(str) {
        return str === null || str === undefined || ("" + str).length === 0;
    }

    backToList() {
        this.props.history.push('/admin/users/list');
    }

    handleTextInputChange(name, value) {
        let user = this.state.user;
        user[name] = value;
        this.setState({
            user: user
        });
    }

    handleIsCrossSectorChange(value) {
        this.state.user.isCrossSector = value;
        if (this.state.user.isCrossSector) {
            this.state.user.subCompanyId = null;
            this.reloadSectorsRefs(this.state.user.companyId, null);
        }
        this.setState(this.state);
    }

    handleCompanyChange(selection) {
        this.state.user.companyId = selection ? selection.value : null;
        this.state.user.companyInn = selection ? selection.inn : null;
        this.reloadCompanyRefs(this.state.user.companyId);
        this.reloadSectorsRefs(this.state.user.companyId, this.state.user.subCompanyId);
        this.setState(this.state);
    }

    handleSubCompanyChange(selection) {
        this.state.user.subCompanyId = selection ? selection.value : null;
        this.reloadSectorsRefs(this.state.user.companyId, this.state.user.subCompanyId);
        this.setState(this.state);
    }

    handleCostCenterChange(selection) {
        this.state.user.costCenterId = selection ? selection.value : null;
        this.setState(this.state);
    }

    handleCarrierChange(selection) {
        this.state.user.carrierId = selection ? selection.value : null;
        this.setState(this.state);
    }

    handleRolesChange(selection) {
        if (selection) {
            this.state.user.roles = selection.map((entry, ind, array) => entry.value);
        } else {
            this.state.user.roles = [];
        }

        // Если убрали роль "Carrier", то очищаем carrierId
        if (!this.state.user.roles.includes('Carrier')) {
            this.state.user.carrierId = null;
        }

        this.setState(this.state);
    }

    handleSelectedAllChange(newChecked) {
        if (newChecked) {
            this.setState({
                selectedUserCompanyIds: this.state.userCompanies.map(entity => entity.id),
                isUserCompaniesSelectedAll: true
            });

        } else {
            this.setState({
                selectedUserCompanyIds: [],
                isUserCompaniesSelectedAll: false
            });
        }
    }

    handleRowSelectionChanged(rowId, newChecked) {
        let newSelectedUserCompanyIds = this.state.selectedUserCompanyIds;
        if (newChecked && newSelectedUserCompanyIds.indexOf(rowId) === -1) {
            newSelectedUserCompanyIds.push(rowId);
        } else if (!newChecked) {
            let idIndex = newSelectedUserCompanyIds.indexOf(rowId);
            if (idIndex >= 0) {
                newSelectedUserCompanyIds.splice(idIndex, 1);
            }
        }
        this.setState({
            selectedUserCompanyIds: newSelectedUserCompanyIds,
            isSelectedAll: newSelectedUserCompanyIds.length > 0 ? null : false
        });
    }

    renderSelectionTitle() {
        let isBusy = this.state.busyCount > 0;
        return (
            <div className="text-center" style={{ width: "24px" }}>
                <TripleStateCheckbox checked={this.state.isUserCompaniesSelectedAll}
                    onChange={e => this.handleSelectedAllChange(e)}
                    disabled={isBusy} />
            </div>
        );
    }

    renderUserCompaniesTable() {
        let userRoles = this.state.user.roles;
        let currentRoles = getRoles();
        if (!(userRoles && userRoles.filter(r => r === 'Coordinator' || r === 'Admin').length > 0))
            return null;
        if (!(currentRoles && currentRoles.includes('GlobalAdmin')))
            return null;

        return (
            <div>
                <section className="content-header" style={{ paddingTop: 20, paddingLeft: 0 }}>
                    <h1>Юр лица</h1>
                </section>
                <section className="content no-padding">
                    <div className="box grid-box no-border no-padding" style={{ height: this.state.boxHeight, width: 685 }}>
                        <div className="box-header no-border">
                        </div>
                        <div className="box-body no-border no-padding">
                            <Grid columns={this.state.columns}
                                loadData={(settings, take, skip, needOverlay) => this.loadUserCompanies(settings, take, skip, needOverlay)}
                                renderCellValue={(row, column) => this.renderCellValue(row, column)}
                                gridKey="admin-usercompanies"
                                isLoadingRowVisible="true"
                                ref={grid => this.grid = grid}
                            />
                        </div>
                    </div>
                </section>
            </div>
        );
    }

    renderCellValue(row, column) {
        let isBusy = this.state.busyCount > 0;
        switch (column.fieldName) {
            case 'selection':
                return (
                    <input type="checkbox"
                        checked={this.state.selectedUserCompanyIds.indexOf(row.id) >= 0}
                        onChange={e => this.handleRowSelectionChanged(row.id, e.target.checked)}
                        disabled={isBusy} />
                );
            default:
                return row[column.fieldName];
        }
    }

    render() {
        let roles = getRoles();
        let hasAccess = roles.includes('Admin') || roles.includes('GlobalAdmin') || roles.includes('ClientAdmin');
        if (!hasAccess || this.state.lastResponseError === 403) {
            return <Forbidden />;
        }
        if (this.state.lastResponseError === 404) {
            return <NotFound />;
        }

        let isNew = this.state.id < 1;
        let isBusy = this.state.busyCount > 0;
        let header = isNew
            ? (
                <section className="content-header">
                    <h1>Новый пользователь</h1>
                    <ol className="breadcrumb">
                        <li><a><i className="fa fa-cogs"></i> Администрирование</a></li>
                        <li><NavLink to="/admin/users/list">Пользователи</NavLink></li>
                        <li className="active">Новый пользователь</li>
                    </ol>
                </section>
            )
            : (
                <section className="content-header">
                    <h1>Пользователь {this.state.user.login}</h1>
                    <ol className="breadcrumb">
                        <li><a><i className="fa fa-cogs"></i> Администрирование</a></li>
                        <li><NavLink to="/admin/users/list">Пользователи</NavLink></li>
                        <li className="active">{this.state.user.login}</li>
                    </ol>
                </section>
            );
        let passwordPlaceholder = isNew ? "" : "Для смены пароля укажите новый...";
        return (
            <div>
                {header}
                <section className="content">
                    <div className="row">
                        <div className="col-xs-12 col-lg-10 col-lg-offset-1">
                            <div className="box box-primary">
                                <div className="box-body">
                                    <div className="row">
                                        <div className="col-sm-6">

                                            <div className={"form-group" + (this.state.errors.email ? " has-error" : "")}>
                                                <label htmlFor="inputEmail">Email</label>
                                                <TextInput type="email"
                                                    id="inputEmail"
                                                    title={this.state.errors.email}
                                                    value={this.state.user.email}
                                                    onChange={value => this.handleTextInputChange("email", value)}
                                                    disabled={isBusy || this.state.id}
                                                />
                                            </div>

                                            {this.state.id ? (
                                                <div className={"form-group" + (this.state.errors.accessToken ? " has-error" : "")}>
                                                    <label htmlFor="inputAccessToken">Токен</label>
                                                    <TextInput id="inputAccessToken"
                                                        title={this.state.errors.accessToken}
                                                        value={this.state.user.accessToken}
                                                        disabled
                                                    />
                                                </div>
                                            ): (
                                                <div className={"form-group" + (this.state.errors.password ? " has-error" : "")}>
                                                    <label htmlFor="inputPassword">Password</label>
                                                    <TextInput type="password"
                                                        id="inputPassword"
                                                        placeholder={passwordPlaceholder}
                                                        title={this.state.errors.password}
                                                        value={this.state.user.password}
                                                        onChange={value => this.handleTextInputChange("password", value)}
                                                        disabled={isBusy}
                                                    />
                                                </div>
                                            )}

                                            <div className={"form-group" + (this.state.errors.surname ? " has-error" : "")}>
                                                <label htmlFor="inputSurname">Фамилия</label>
                                                <TextInput id="inputSurname"
                                                    title={this.state.errors.surname}
                                                    value={this.state.user.surname}
                                                    onChange={value => this.handleTextInputChange("surname", value)}
                                                    disabled={isBusy}
                                                />
                                            </div>

                                            <div className={"form-group" + (this.state.errors.name ? " has-error" : "")}>
                                                <label htmlFor="inputName">Имя</label>
                                                <TextInput id="inputName"
                                                    title={this.state.errors.name}
                                                    value={this.state.user.name}
                                                    onChange={value => this.handleTextInputChange("name", value)}
                                                    disabled={isBusy}
                                                />
                                            </div>

                                            <div className={"form-group" + (this.state.errors.patronymic ? " has-error" : "")}>
                                                <label htmlFor="inputPatronymic">Отчество</label>
                                                <TextInput id="inputPatronymic"
                                                    title={this.state.errors.patronymic}
                                                    value={this.state.user.patronymic}
                                                    onChange={value => this.handleTextInputChange("patronymic", value)}
                                                    disabled={isBusy}
                                                />
                                            </div>

                                            <div className={"form-group" + (this.state.errors.contactInfo ? " has-error" : "")}>
                                                <label htmlFor="inputContactInfo">Телефон</label>
                                                <CountryPhoneInput id="inputContactInfo"
                                                    title={this.state.errors.contactInfo}
                                                    value={this.state.user.contactInfo}
                                                    onChange={value => this.handleTextInputChange("contactInfo", value)}
                                                    onEditComplete={() => {}}
                                                    disabled={isBusy}
                                                    defaultCountry="ru"
                                                />
                                            </div>

                                        </div>
                                        <div className="col-sm-6">
                                            <div className={"form-group" + (this.state.errors.companyId ? " has-error" : "")}>
                                                <label htmlFor="selectCompany">Юр. лицо</label>
                                                <SelectInput id="selectCompany"
                                                    options={this.state.companies}
                                                    value={this.state.user.companyId}
                                                    title={this.state.errors.companyId}
                                                    onChange={e => this.handleCompanyChange(e)}
                                                    disabled={isBusy || this.state.adminCompanyId || this.state.id}
                                                />
                                            </div>

                                            <div className={"form-group" + (this.state.errors.subCompanyId ? " has-error" : "")}>
                                                <label htmlFor="selectSubCompany">Сектор</label>
                                                <SelectInput id="selectSubCompany"
                                                    options={this.state.subCompanies}
                                                    value={this.state.user.subCompanyId}
                                                    title={this.state.errors.subCompanyId}
                                                    onChange={e => this.handleSubCompanyChange(e)}
                                                    disabled={isBusy || this.state.user.isCrossSector}
                                                />
                                            </div>

                                            <div className={"form-group" + (this.state.errors.costCenterId ? " has-error" : "")}>
                                                <label htmlFor="selectCostCenter">Кост Центр</label>
                                                <SelectInput id="selectCostCenter"
                                                    options={this.state.costCenters}
                                                    value={this.state.user.costCenterId}
                                                    title={this.state.errors.costCenterId}
                                                    onChange={e => this.handleCostCenterChange(e)}
                                                    disabled={isBusy}
                                                />
                                            </div>

                                            <div className={"form-group" + (this.state.errors.roles ? " has-error" : "")}>
                                                <label htmlFor="selectRoles">Роли</label>
                                                <SelectInput id="selectRoles"
                                                    options={this.state.roles} multi
                                                    value={this.state.user.roles}
                                                    title={this.state.errors.roles}
                                                    onChange={e => this.handleRolesChange(e)}
                                                    disabled={isBusy}
                                                />
                                            </div>

                                            <div className={"form-group" + (this.state.errors.carrierId ? " has-error" : "")}>
                                                <label htmlFor="selectCarrier">Транспортная компания</label>
                                                <SelectInput id="selectCarrier"
                                                    options={this.state.carriers}
                                                    value={this.state.user.carrierId}
                                                    title={this.state.errors.carrierId}
                                                    onChange={e => this.handleCarrierChange(e)}
                                                    disabled={isBusy || !this.state.user.roles.includes('Carrier')}
                                                />
                                            </div>

                                            <div className={"form-group" + (this.state.errors.comment ? " has-error" : "")}>
                                                <label htmlFor="inputComment">Комментарий</label>
                                                <TextInput id="inputComment"
                                                    title={this.state.errors.comment}
                                                    value={this.state.user.comment}
                                                    onChange={value => this.handleTextInputChange("comment", value)}
                                                    disabled={isBusy}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {this.renderUserCompaniesTable()}
                                </div>
                                <div className="box-footer">
                                    <button className="btn btn-flat btn-default" onClick={() => this.backToList()} disabled={isBusy}>
                                        Отмена
                                    </button>
                                    <button className="btn btn-flat btn-primary pull-right" onClick={() => this.save()} disabled={isBusy}>
                                        Сохранить
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <InformationModal ref={modal => this.infoModal = modal} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/pages/admin/users/userForm.jsx